import { PregnancyCompletionType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

const PREGNANCY_COMPLETION_TYPE_FIELD_NAME = 'completionType';

type PatientPregnancyCompletionTypeFormBeanPart = {
   [PREGNANCY_COMPLETION_TYPE_FIELD_NAME]: PregnancyCompletionType | null;
};

type PatientPregnancyCompletionTypeSelectProps = {
   readonly register: BindingCreator<PatientPregnancyCompletionTypeFormBeanPart>;
};

const useTriggerLabelExtractor = (): ((pregnancyCompletionType: PregnancyCompletionType) => string) => {
   const translate = useTranslate();
   return (pregnancyCompletionType) =>
      translate(visitPatientPregnancyStatusTranslationKeys.pregnancyCompletionType[pregnancyCompletionType]);
};

const pregnancyCompletionTypes: PregnancyCompletionType[] = ['DELIVERY', 'DEAD_DELIVERY', 'MISCARRIAGE', 'OTHER'];

export const PatientPregnancyCompletionTypeSelect = (props: PatientPregnancyCompletionTypeSelectProps): JSX.Element => {
   return (
      <Select<PregnancyCompletionType>
         testId={'pregnancyCompletionType'}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         label={visitPatientPregnancyStatusTranslationKeys.completionType}
         placeholder={visitPatientPregnancyStatusTranslationKeys.choose}
         controller={props.register(PREGNANCY_COMPLETION_TYPE_FIELD_NAME, { required: true })}
      >
         <Select.List<PregnancyCompletionType> items={pregnancyCompletionTypes}>
            {(pregnancyCompletionType) => (
               <Select.Item
                  item={pregnancyCompletionType}
                  label={visitPatientPregnancyStatusTranslationKeys.pregnancyCompletionType[pregnancyCompletionType]}
                  testId={pregnancyCompletionType}
               />
            )}
         </Select.List>
      </Select>
   );
};
